<template>
    <e-tooltip v-if="useTooltip" :position="position" :label="formatDate(date, displayFormat)" :append-to-body="appendToBody" class="tw:inline-block">
        {{ displayDateFormat ? formatDate(date, displayFormat) : formatDate(date, null, true) }}
    </e-tooltip>

    <span v-else>{{ formatDate(date, displayFormat) }}</span>
</template>

<script>
export default {
    name: 'DateFormat',

    props: {
        date: {
            required: true,
            type: [Object, String],
        },

        format: {
            default: null,
            required: false,
            type: [String],
        },

        position: {
            default: 'is-top',
            required: false,
            type: String,
        },

        displayDateFormat: {
            default: false,
            required: false,
            type: Boolean,
        },

        appendToBody: {
            default: true,
            required: false,
            type: Boolean,
        },

        useTooltip: {
            default: true,
            required: false,
            type: Boolean,
        },
    },

    computed: {
        displayFormat() {
            return this.format ? this.format : 'MM/DD/YYYY hh:mm:ss a zz';
        },
    },
};
</script>
